import React, { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTheme } from "../../../ThemeContext"; // Adjust the path as necessary
import ReportForm from './Report'
import SectionForm from './AddSection'
import StructureForm from './AddStructure'
const AddReport = ({ open, onClose,project }) => {
  const { theme } = useTheme(); // Get the theme from context
  const [action, setAction] = useState(""); // Track selected action
  const [itemType, setItemType] = useState(""); // Track selected item type
  const cancelButtonRef = useRef(null);

  const handleActionChange = (e) => {
    setAction(e.target.value);
    setItemType(""); // Reset itemType when action changes
  };

  const handleItemTypeChange = (e) => setItemType(e.target.value);

  const renderDynamicComponent = () => {
    switch (itemType) {
      case "Structure":
        return <StructureForm action={action} theme={theme} onClose={onClose} project={project} />;
      case "Report":
        return <ReportForm action={action} theme={theme} onClose={onClose} project={project}/>;
      case "Section":
        return <SectionForm action={action} theme={theme} onClose={onClose} project={project}/>;
      default:
        return null;
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg ${
                  theme === "dark"
                    ? "bg-gray-800 text-white"
                    : "bg-white text-gray-900"
                } text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg`}
              >
                <div
                  className={`${
                    theme === "dark" ? "bg-gray-800" : "bg-white"
                  } px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}
                >
                  <div className="text-center">
                    <h3 className="text-lg font-semibold">Manage Items</h3>
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium">Action</label>
                    <select
                      value={action}
                      onChange={handleActionChange}
                      className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${
                        theme === "dark"
                          ? "bg-gray-700 text-white border-gray-600"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Action
                      </option>
                      <option value="Add">Add</option>
                      <option value="Edit">Edit</option>
                      <option value="Delete">Delete</option>
                    </select>
                  </div>
                  {action && (
                    <div className="mb-4">
                      <label className="block text-sm font-medium">
                        Item Type
                      </label>
                      <select
                        value={itemType}
                        onChange={handleItemTypeChange}
                        className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${
                          theme === "dark"
                            ? "bg-gray-700 text-white border-gray-600"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Item Type
                        </option>
                        <option value="Structure">Structure</option>
                        <option value="Report">Report</option>
                        <option value="Section">Section</option>
                      </select>
                    </div>
                  )}
                  {itemType && renderDynamicComponent()}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AddReport;
